import React from 'react';
import { CommandBarButton } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ClearButton = _ref => {
  let {
    onClear,
    label
  } = _ref;
  const clearIcon = {
    iconName: 'BoxMultiplySolid'
  };
  return /*#__PURE__*/_jsx(CommandBarButton, {
    iconProps: clearIcon,
    text: label !== null && label !== void 0 ? label : 'Clear',
    onClick: onClear
  });
};